/**
 * @generated SignedSource<<bb9e2d5b252c543aa90ead2a8d446276>>
 * @relayHash 6feddd3cd0ebd8c6c0af996a95e0351e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0d55a64482985de626434869bb8931fe079c5b408aae97a6df2713c9281c2589

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type navLinksQuery$variables = {
  cloudId: string;
  hubAri: string;
  isConfigurableSiteTreeEnabled: boolean;
  isDraft?: boolean | null;
  isTopicsEnabled: boolean;
};
export type navLinksQuery$data = {
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly " $fragmentSpreads": FragmentRefs<"moreDropdown_AtlassianHubAppShell" | "portalDropdown_AtlassianHubAppShell" | "siteNavigation_AtlassianHubAppShell" | "topicDropdown_AtlassianHubAppShell">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
};
export type navLinksQuery = {
  response: navLinksQuery$data;
  variables: navLinksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isConfigurableSiteTreeEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDraft"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTopicsEnabled"
},
v5 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v6 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "hubAri"
  },
  {
    "kind": "Variable",
    "name": "isDraft",
    "variableName": "isDraft"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
],
v10 = [
  (v8/*: any*/),
  {
    "concreteType": "HelpCenterPageName",
    "kind": "LinkedField",
    "name": "name",
    "plural": false,
    "selections": (v9/*: any*/)
  }
],
v11 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "HelpCenterPage"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "navLinksQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "portalDropdown_AtlassianHubAppShell"
                  },
                  {
                    "condition": "isTopicsEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "topicDropdown_AtlassianHubAppShell"
                      }
                    ]
                  },
                  {
                    "condition": "isConfigurableSiteTreeEnabled",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "moreDropdown_AtlassianHubAppShell"
                      }
                    ]
                  },
                  {
                    "condition": "isConfigurableSiteTreeEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "siteNavigation_AtlassianHubAppShell"
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "navLinksQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "HelpCenterPortals",
                    "kind": "LinkedField",
                    "name": "portals",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterPortal",
                        "kind": "LinkedField",
                        "name": "portalsList",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "isTopicsEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "topicPages",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "ids": [],
                              "type": "TOPIC"
                            }
                          }
                        ],
                        "concreteType": "HelpCenterPage",
                        "kind": "LinkedField",
                        "name": "pages",
                        "plural": true,
                        "selections": (v10/*: any*/),
                        "storageKey": "pages(filter:{\"ids\":[],\"type\":\"TOPIC\"})"
                      }
                    ]
                  },
                  {
                    "condition": "isConfigurableSiteTreeEnabled",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "alias": "customPages",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "ids": [],
                              "type": "CUSTOM"
                            }
                          }
                        ],
                        "concreteType": "HelpCenterPage",
                        "kind": "LinkedField",
                        "name": "pages",
                        "plural": true,
                        "selections": (v10/*: any*/),
                        "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                      }
                    ]
                  },
                  {
                    "condition": "isConfigurableSiteTreeEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "HelpCenterSiteTree",
                        "kind": "LinkedField",
                        "name": "siteTree",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "HelpCenterFolder",
                            "kind": "LinkedField",
                            "name": "root",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "HelpCenterSiteTreeNodeConnection",
                                "kind": "LinkedField",
                                "name": "contents",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v11/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v8/*: any*/),
                                          {
                                            "concreteType": "HelpCenterFolderName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": (v9/*: any*/)
                                          },
                                          {
                                            "concreteType": "HelpCenterSiteTreeNodeConnection",
                                            "kind": "LinkedField",
                                            "name": "contents",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "nodes",
                                                "plural": true,
                                                "selections": [
                                                  (v7/*: any*/),
                                                  (v11/*: any*/),
                                                  (v12/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "HelpCenterFolder"
                                      },
                                      (v12/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v8/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              (v12/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0d55a64482985de626434869bb8931fe079c5b408aae97a6df2713c9281c2589",
    "metadata": {},
    "name": "navLinksQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8632fa4c2480ce4d0cf74a6703739408";

export default node;
